<template>
  <div class="class-list-page">
    <list-page-header />

    <yv-index
      :path="path"
      :formSearch="formSearch"
      :columns="columns"
      :tableActionsComponent="TableActions"
      :sortable="sortable"
      :formatTableData="formatTableData"
      mainField="grade_scale_name"
      ref="gradeScaleTableIns"
    >
    </yv-index>

    <common-modal
      :name="confirmModalProps.name"
      :title="confirmModalProps.title"
      :primaryAction="confirmModalProps.primaryAction"
      :secondaryActions="confirmModalProps.secondaryActions"
      height="auto"
    >
      <template #modal-body>
        {{ confirmModalProps.content }}
      </template>
    </common-modal>
  </div>
</template>

<script>
import { YvIndex } from "@/components/Base";
import { service_paths } from "@/constants/Services";
import Header from "./Header";
import TableActions from "./TableActions.vue";
import { Message } from "@/helpers/utils";
export default {
  name: "ListPage",
  components: { YvIndex, ListPageHeader: Header },
  data() {
    return {
      path: service_paths.grade_scales,
      TableActions,
      formSearch: [
        {
          label: this.$t("grade_scale.name"),
          name: "name__~",
          value: "",
          type: "input"
        }
      ],
      columns: {
        name: "grade_scale.col_name",
        calculate_GPA: "grade_scale.col_calculate_GPA",
        number_subject: "grade_scale.col_number_subject"
      },
      sortable: ["name"],
      confirmModalProps: {
        name: "confirm-modal",
        title: "common.confirmation",
        primaryAction: {
          title: "common.delete",
          actions: () => {},
          class: "md-danger"
        },
        secondaryActions: [
          {
            title: "common.cancel",
            action: () => {}
          }
        ],
        content: ""
      }
    };
  },
  methods: {
    getGradeScaleId(classObj) {
      return classObj.id || classObj._id;
    },
    reFetchTableData() {
      return this.$refs.gradeScaleTableIns.getTableData();
    },
    formatTableData(tableData) {
      return tableData.map(scaleData => {
        scaleData.calculate_GPA = scaleData.is_calculate_gpa
          ? this.$t("common.yes")
          : this.$t("common.no");
        scaleData.number_subject =
          scaleData?.subjects?.length?.toString() ?? "0";
        return scaleData;
      });
    },
    genModalCancelAction() {
      return {
        title: this.$t("common.cancel"),
        action: () => {
          this.$modal.hide(this.confirmModalProps.name);
        }
      };
    },
    async confirmDelete(classObj) {
      const gradeScaleId = this.getGradeScaleId(classObj);

      try {
        // set-up modal data
        const gradeScaleRes = await this.$axios.get(
          `${this.path}/${gradeScaleId}`
        );

        const classQuantity =
          gradeScaleRes && gradeScaleRes?.data?.classes?.length;

        if (!!classQuantity) {
          this.confirmModalProps = Object.assign({}, this.confirmModalProps, {
            content: this.$t("grade_scale.can_not_delete"),
            primaryAction: {
              title: "OK",
              action: () => {
                this.$modal.hide(this.confirmModalProps.name);
              }
            },
            secondaryActions: []
          });
          return;
        }
        this.confirmModalProps = Object.assign({}, this.confirmModalProps, {
          content: this.$t("grade_scale.are_you_sure_to_delete"),
          primaryAction: {
            title: this.$t("common.delete"),
            action: () => {
              this.$axios
                .delete(`${this.path}/${gradeScaleId}`)
                .then(async () => {
                  await this.reFetchTableData();
                  Message.success(this.$t("common.delete_success"));
                })
                .finally(() => {
                  this.$modal.hide(this.confirmModalProps.name);
                });
            },
            class: "md-danger"
          },
          secondaryActions: [{ ...this.genModalCancelAction() }]
        });
      } catch (error) {
        console.log("check student failed: ", error);
      } finally {
        this.$modal.show(this.confirmModalProps.name);
      }
    }
  },
  provide() {
    return {
      confirmDelete: this.confirmDelete
    };
  }
};
</script>
